// extracted by mini-css-extract-plugin
export default {"about":"styles_about__GLa7B","up":"styles_up__lczj5","loading":"styles_loading__SJdoi"};